/* eslint-disable import/no-cycle */
import { action, makeObservable, observable } from 'mobx';
import BaseStore from './base-stores/BaseStore';
import { RootStore } from './RootStore';
import DataFordelerClient from '../utils/datafordeler/DatafordelerClient';
import {
  DatafordelerAddress,
  DatafordelerAutocomplete,
  DatafordelerAutocompleteResponse
} from '../utils/datafordeler/types';

export default class AddressSelectorStore extends BaseStore {
  dataFordererClient: DataFordelerClient = new DataFordelerClient();

  useDatafordelerSelector: boolean = true;

  addressOptions: { value: string; id: string | undefined }[] = [];

  selectedAddress: DatafordelerAddress | undefined = undefined;

  isOptionDropdownOpen: boolean = false;

  setUseDatafordelerSelector = (useDatafordeler: boolean) => {
    this.useDatafordelerSelector = useDatafordeler;
  };

  setIsOptionDropdownOpen = (isOpen: boolean) => {
    this.isOptionDropdownOpen = isOpen;
  };

  setSelectedAddress = (selectedAddress: string | undefined) => {
    const addressId = this.addressOptions.find((x) => x.value === selectedAddress)?.id;
    if (!addressId) {
      return Promise.resolve();
    }

    const promise = this.dataFordererClient
      .FindAddressDetails(addressId)
      .then((response: DatafordelerAddress | undefined) => {
        this.selectedAddress = response;
        this.setIsOptionDropdownOpen(false);
      });

    return promise;
  };

  setAddressOptions = (addressInput: string) => {
    if (!addressInput || addressInput.length < 3) {
      return Promise.resolve();
    }

    const promise = this.dataFordererClient
      .FindAddressWithAutocomplete(addressInput ?? '')
      .then((response: DatafordelerAutocompleteResponse) => {
        const addAddressValue = (adr: DatafordelerAutocomplete) => ({
          value: adr.titel,
          id: adr.id
        });
        const adrOptions: { value: string; id: string | undefined }[] = response.fund.map(
          (adr: DatafordelerAutocomplete) => addAddressValue(adr)
        );
        this.addressOptions = adrOptions;
      });

    return promise;
  };

  constructor(rootStore: RootStore) {
    super(rootStore);
    makeObservable(this, {
      addressOptions: observable,
      selectedAddress: observable,
      isOptionDropdownOpen: observable,
      useDatafordelerSelector: observable,
      setUseDatafordelerSelector: action,
      setIsOptionDropdownOpen: action,
      setAddressOptions: action,
      setSelectedAddress: action
    });
  }
}
